import React from 'react'

import { PermissionChecker } from '../../session'
import PublicTokenLoader from './_load/PublicTokenLoader'
import ControlledModal from '../../../components/modals/ControlledModal'
import EditPublicTokenForm from './EditPublicTokenForm'
import ModalHeader from './ModalHeader'

const EditPublicTokenModal = props => {
  return (
    <ControlledModal width="42rem" disableClickOutside zIndex={'10000'} {...props}>
      <PermissionChecker any={['createPublicToken', 'editPublicToken']}>
        <ModalHeader />
        <PublicTokenLoader>
          <EditPublicTokenForm />
        </PublicTokenLoader>
      </PermissionChecker>
    </ControlledModal>
  )
}

export default EditPublicTokenModal
